import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { user, isLoggedIn } = useSelector((state: any) => state.auth);

    if (!isLoggedIn || user.role !== 'ROLE_ADMIN') {
        // Redirect to login or access denied page if not authorized
        return <Navigate to="/user/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
